import { request } from "../@utils";
import { requestFile } from "../@utils";
const areaService = {
  saveArea: async (params) => {
    const res = await request.post("/area/model/save",{ data: params });
    return res;
  },
  deleteArea: async (id) => {
    const res = await request.get(`/area/model/delete?id=${id}`);
    return res;
  },
  getAreaPageList: async (params) => {
    const res = await request.post("/area/model/page",{ data: params });
    return res;
  },
  getAreaDetail: async (id) => {
    const res = await request.get(`/area/model/get?id=${id}`);
    return res;
  },
};
export default areaService;